import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubble3"><Path d="M12.0001 2C6.47721 2 2.00006 6.47715 2.00006 12C2.00006 13.5557 2.35584 15.0303 2.99102 16.3451L1.79102 22.1925L7.7854 21.0709C9.06701 21.6673 10.4956 22 12.0001 22C17.5229 22 22.0001 17.5228 22.0001 12C22.0001 6.47715 17.5229 2 12.0001 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble3;
